const StrateFaq = {

    init() {
        // TODO gestion du device pour detruire l'observer en mobile
        this.initNavigation();
    },

    initNavigation() {
        this.$faqNav = document.querySelector('.js-menu-categories-faqs');
        
        if (this.$faqNav) {
            this.$faqNavAnchors = this.$faqNav.querySelectorAll('a[href^="#"]');

            this.observer = new IntersectionObserver(entries => {
                const $anchor = document.querySelector(`a[href="#${entries[0].target.getAttribute('id')}"]`);

                if (entries[0].intersectionRatio > 0.2) {
                    $anchor.classList.add('active');
                } else {
                    $anchor.classList.remove('active');
                }
            }, { threshold: 0.2 });
            
            this.$faqNavAnchors.forEach($anchor => {
                const $element = document.querySelector($anchor.getAttribute('href'));
                this.observer.observe($element);
            });
        }
    },

    destroyNavigation() {
        this.$faqNavAnchors.forEach($anchor => {
            const $element = document.querySelector($anchor.getAttribute('href'));
            this.observer.unobserve($element);
        });
    },
};

export default StrateFaq;
